import { render, staticRenderFns } from "./filter-auftraggeber.vue?vue&type=template&id=515f6f7b&scoped=true&"
import script from "./filter-auftraggeber.vue?vue&type=script&lang=js&"
export * from "./filter-auftraggeber.vue?vue&type=script&lang=js&"
import style0 from "./filter-auftraggeber.vue?vue&type=style&index=0&id=515f6f7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f6f7b",
  null
  
)

export default component.exports